export default __webpack_public_path__ + "static/media/flagger.d1a9fd91.png";